module.exports = __webpack_public_path__ + "img/tutorial_war_03.f7985699.gif";